export default {
	InvitationCode: "Invitation Code",
	CreditScore: "Credit Score",
	MyFinancial: {
		title: "My Financial",
		menu: ["Deposit", "Withdraw", "Transaction"]
	},
	MyDetail: {
		title: "My Detail",
		menu: ["Personal Information", "Payment Methods"]
	},
	Other: {
		title: "Other",
		menu: ["Contact Us", "Notifications", "Change Language"]
	},
	Amount: ["Wallet Balance", "Frozen Balance", "Today's Earnings"],
	Logout: {
		title: "Logout",
		content: "Are you sure you want to logout?"
	}
};
